import { Ajax } from "./Utils/Ajax";

declare var tippy: any;
declare var panzoom: any;

const tippyInstances = tippy('path', {
    // content(reference) {
    //     const id = reference.getAttribute('data-template');
    //     if (id) {
    //         const template = document.getElementById(id);
    //         return template.innerHTML;
    //     }
    //     return "no content";
    // },
    animation: 'fade',
    arrow: true,
    placement: 'bottom',
    //followCursor: true,
    allowHTML: true,
    theme: 'light',
});

// just grab a DOM element
var element = document.querySelector('#mapa .vector')

// And pass it to panzoom
let instance = panzoom(element, {
    maxZoom: 3,
    minZoom: 1,
    bounds: true,
    boundsPadding: 1,
    zoomDoubleClickSpeed: 1,
});

// instance.on('transform', function () {
//     // This event will be called along with events above.
//     // console.log(instance.getTransform());
// });

let algojeje = function() {
    $(".vector path.casa").on("click touchend", function(){
        instance.pause();
        $("#mapa .modal .loader").show();
        $("#mapa .modal").fadeIn();
        let id = $(this).attr("id-casa");
        let ajaxService = new Ajax.Service();
        let ajaxOptions = new Ajax.Options(`get-datos-casa/${id}`, "get", {}, "json");
        ajaxService.request(ajaxOptions, function(response: any){
           $("#mapa .modelo-casa .modelo").text(response.modelo_casa);
           $("#mapa .imagen-casa img").attr("src", response.imagen_casa.full_route_file);
           $("#mapa .numero .numero-casa").text(response.id_publico_casa);
    
            let dispon = "";
            switch (response.estatus_casa) {
                case "No Disponible":
                    dispon = "no-disponible";
                    break;
                case "Disponible":
                    dispon = "disponible";
                    break;    
                case "Vendido":
                    dispon = "vendido";
                    break;
                case "Apartado":
                    dispon = "apartado";
                    break;
            }
    
            let $element = $("#mapa .disponibilidad").removeClass();
            $element.addClass(`disponibilidad ${dispon}`);
            $element.find(".estado").text(response.estatus_casa);
    
           $("#mapa .tereno .terreno-casa").text(response.terreno_casa);
           $("#mapa .precio .precio-casa").text(response.precio_md_casa);
           $("#mapa .metros .metros-casa").text(response.metrosc_casa);
           $("#mapa .posibilidad-expansion .posibilidad-expansion-casa").text(response.expansion_casa);        
           if(response.expansion_casa == "No"){
                $("#mapa .precio-expansion").hide();
           }else{
                $("#mapa .precio-expansion").show();
           }
           $("#mapa .precio-expansion .precio-expansion-casa").text(response.precio_ex_casa);
           $("#mapa .modal .loader").hide();
        }, function(response: any){
            instance.resume();
            instance.smoothZoomAbs(0.5, 0.5, 1);
            $("#mapa .modal").fadeOut();
        });
    });
}

$("#mapa .modal .container .close-modal").on("click", function(){
    instance.resume();
    instance.smoothZoomAbs(0.5, 0.5, 1);
    $("#mapa .modal").fadeOut();
});

algojeje();